import React, { Component } from 'react';
import _validator from 'modules/validator';
import _AdminService from 'modules/AdminService';
import _notification from 'modules/notification';
import { Card, Table, Modal, DatePicker, Icon } from 'antd';
import EmptyState from 'components/enterprise/EmptyState';
import PageHeader from 'components/enterprise/PageHeader';
import LoadingSpinner from 'components/enterprise/LoadingSpinner';
import ButtonComponent from 'components/controls/Button';
import { routesAdmin } from 'routes/Routes';
import ConfirmPopup from '../popup/ConfirmPopup';
import MyInput from 'components/controls/MyInput';
import { GENERAL_ERROR_MESSAGE } from 'constants/constants';
import DropdownList from 'components/controls/DropdownList';
import moment from 'moment';

class BatchMaster_new extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pagination: { pageSize: 10, current: 1 },
            highlightedRowID: 0,
            data: [],
            centerList: [],
            exams: [],
            rowData: {},
            loading: false,
            showModel: false,
            showMessageBox: false,
            classError: "",
            centerError: "",
            timeError:""
        };
    }

    componentDidMount() {
        this.getAllExams();
        this.getAllClassRoom();
        this.getAllCenters();
    }

    //API operations
    getAllClassRoom = async () => {
        try {
            this.setState({ loading: true }, async () => {
                try {
                    let classRoomList = await _AdminService.GetAllClassRoom();
                    //console.log("classRoomList Data: ", classRoomList.data);

                    this.setState({
                        ...this.state,
                        data: classRoomList.data,
                        loading: false,
                    });

                } catch (e) {
                    // TODO
                    this.setState({ loading: false });
                    console.log('Error: ', e);
                }
            });
        } catch (e) { }
    }

    getAllCenters = async () => {
        try {
            this.setState({ loading: true }, async () => {
                try {
                    let centerList = await _AdminService.GetAllCenter();
                    //console.log("centerList Data: ", centerList.data);

                    centerList.data.map(item => {
                        item.Name = `${item.Name} (${item.PostName})`;
                    })

                    this.setState({
                        ...this.state,
                        centerList: centerList.data,
                        loading: false,
                    });

                } catch (e) {
                    // TODO
                    this.setState({ loading: false });
                    console.log('Error: ', e);
                }
            });
        } catch (e) { }
    }

    getAllExams = async () => {
        try {
            this.setState({ loading: true }, async () => {
                try {
                    let examsList = await _AdminService.GetAllPost();
                    //console.log("examsList Data: ", examsList.data);

                    this.setState({
                        ...this.state,
                        exams: examsList.data,
                        loading: false,
                    });

                } catch (e) {
                    // TODO
                    this.setState({ loading: false });
                    console.log('Error: ', e);
                }
            });
        } catch (e) { }
    }

    handleUpdate = async (input) => {
        if (this.validateFormData()) {
            return
        }

        const params = {
            Name: this.state.rowData.Name.trim(),
            //Description: this.state.rowData.Description.trim(),
            Id: this.state.rowData.Id,
            Center_Id: this.state.rowData.Center_Id,
            Exam_Date: this.state.rowData.Exam_Date,
            Exam_Time: this.state.rowData.Exam_Time,
        }

        //console.log("Final data: ", params);

        try {
            this.setState({ loading: true }, async () => {
                try {
                    const response = await _AdminService.CreateClassRoom(params);
                    //console.log("Post response: ", response);
                    if (response.status == 200) {
                        _notification.showMessage('success', "Batch saved successfully.");
                        this.setState({
                            centerError: "",
                            classError: "",
                            timeError:"",
                            showModel: false,
                            loading: false,
                            highlightedRowID: params.Id
                        });
                        this.getAllClassRoom();
                    }
                    else {
                        _notification.showMessage('error', response.data.message);
                    }
                } catch (e) {
                    // TODO
                    this.setState({ loading: false });
                    console.log('Error: ', e);
                    _notification.showMessage('error', GENERAL_ERROR_MESSAGE);
                }
            });
        } catch (e) { }
    }

    deletePost = async (value) => {
        const params = {
            Name: this.state.rowData.Name,
            Id: this.state.rowData.Id
        }

        //console.log("Final data: ", params);
        try {
            const response = await _AdminService.DeleteClassRoom(this.state.rowData.Id);
            //console.log("Post response: ", response);
            if (response.status == 200 && response.data.IsSuccess) {
                _notification.showMessage('success', "Batch deleted successfully.");
                this.setState({
                    centerError: "",
                    classError: "",
                    timeError:"",
                    showModel: false
                });
                this.getAllClassRoom();
            }
            else {
                _notification.showMessage('error', response.data.Message);
            }
        } catch (e) {
            _notification.showMessage('error', GENERAL_ERROR_MESSAGE);
        }
    }

    //Table action link clicks
    onEditClick = (value) => {
        //console.log('params ', value);
        this.setState({ rowData: value, showModel: true, highlightedRowID: 0, timeError:'', classError:'', centerError:'' },()=>{
            window.scrollTo(0, 0);
        });
    };

    onDeleteClick = (value) => {
        //console.log('params ', value);
        this.setState({ rowData: value, showMessageBox: true, highlightedRowID: 0 });
    };

    onTableAction = (pagination, filters, sorter, extra) => {
        //console.log('onTableAction ', pagination, filters, sorter, extra);
        this.setState({ pagination: pagination, highlightedRowID: 0 });
    }

    //Message box confirm delete click
    onConfirmDelete = (value) => {
        //console.log('reached in delete:  ', value);
        this.setState({ showMessageBox: false });
        this.deletePost(value);
    }

    closeMessageBox(value = false) {
        this.setState({ showMessageBox: value });
    }

    // Add new record click
    onAddNewRecordClick(modelToggle) {
        this.setState({ showModel: modelToggle, rowData: {}, timeError:'', classError:'', centerError:''  });
    }

    hideModelWindow() {
        this.setState({ showModel: false, rowData: {} });
    }

    onTextChange = ({ target: { name, value } }) => {
        if (name == 'Name' && value.length > 50)
            return;

        if (name == 'Description' && value.length > 100)
            return;

        this.setState({
            ...this.state,
            rowData: { Id: this.state.rowData.Id, ...this.state.rowData, [name]: value }
        });

        this.setState({ [name]: value.trim() });
    }

    onCenterChange = (event) => {
        this.setState({
            ...this.state,
            rowData: { Id: this.state.rowData.Id, ...this.state.rowData, Center_Id: event.target.value }
        });
    }

    onDateChange = (date, dateString) => {
        this.setState({
            ...this.state,
            rowData: { ...this.state.rowData, Exam_Date: date ? date.format("YYYY-MM-DDT00:00:00") : "" }
        });
    };

    validateFormData = () => {
        let body = this.state.rowData;

        this.setState({
            centerError: '',
            classError: '',
            timeError:''
        });

        let hasError = false;

        if (!body.Name || !body.Name.trim()) {
            this.setState({ classError: 'Please enter valid Batch Name' });
            hasError = true
        }

        if (!body.Center_Id) {
            this.setState({ centerError: 'Please select valid Center.' });
            hasError = true
        }

        if (!body.Exam_Time) {
            this.setState({ timeError: 'Please select valid Batch Time.' });
            hasError = true
        }

        return hasError;
    }

    render() {
        const TableColumns = [
            {
                title: 'Batch Name',
                dataIndex: 'Name',
                filterSearch: true,
                width: '10%',
                key: 'Name',
                sorter: (a, b) => a.Name > b.Name
            },
            {
                title: 'Batch Date',
                dataIndex: 'Exam_Date',
                filterSearch: true,
                width: '13%',
                key: 'Exam_Date',
                sorter: (a, b) => a.Exam_Date.localeCompare(b.Exam_Date),
                render: (value, record) => {
                    return (
                        <>
                            {moment(record.Exam_Date).isValid() ? moment(record.Exam_Date).format('DD-MMM-YYYY') : ""}
                        </>
                    );
                }
            },
            {
                title: 'Batch Time',
                dataIndex: 'Exam_Time',
                filterSearch: true,
                width: '20%',
                key: 'Exam_Time',
                //sorter: (a, b) => a.Exam_Time > b.Exam_Time,
            },
            {
                title: 'Center Name',
                dataIndex: 'CenterName',
                filterSearch: true,
                width: '23%',
                key: 'CenterName',
                sorter: (a, b) => a.CenterName > b.CenterName,
                filters: this.state.centerList ? this.state.centerList.map(item => ({ text: item.Name, value: item.Id })) : [],
                onFilter: (value, record) => record.Center_Id === value,
            },
            {
                title: 'Post/Exam',
                dataIndex: '',
                filterSearch: true,
                width: '16%',
                key: '',
                render: (value) => {
                    let exam = this.state.exams.find(item => item.Id == value.AppliedPost_Id);
                    return (!exam ? "" : exam.Name);
                }
            },
            {
                title: 'Action',
                dataIndex: '',
                key: 'Id',
                render: (value) => {
                    return (
                        <>
                            <ButtonComponent type="button" value="Edit" className="button-global button-border small autoHeight mr-2" onClick={(event) => this.onEditClick(value)} />
                            <ButtonComponent type="button" value="Delete" className="button-global button-danger small autoHeight" onClick={(event) => this.onDeleteClick(value)} />
                        </>
                    );
                }
            },
        ];

        if (this.state.loading)
            return <LoadingSpinner />

        return (
            <div className="container-fluid p-3">
                <PageHeader
                    title="Batch Master"
                    breadcrumbItems={[{ label: 'Dashboard', path: routesAdmin.dashboard.path }, { label: 'Batch Master' }]}
                />
                <div className="analysisWrap">
                        <div style={{ textAlign: 'right' }}>
                            {!this.state.showModel &&
                                <div className="max1200 m-auto mb-2"> 
                                    <div className="d-flex align-items-center justify-content-end">
                                        <a className="button-global button-border addbutton autoWidth d-inline-block text-center autoHeight mb-3 mr-2 d-flex align-items-center justify-content-center" 
                                        onClick={() => this.onAddNewRecordClick(true)}><Icon type="plus-circle" className="mr-2 font1rem" /> Add Batch</a>
                            
                                    </div>
                                </div>  
                            }
                        </div>
                        {this.state.showModel &&    
                            <div className="max1200 m-auto">
                                <div className="ent-panel">
                                    <h4 className="heading4">{this.state.rowData ? this.state.rowData.Id > 0 ? "Update" : "Add" : "Add"} Batch </h4>
                                    <div className="admin-inner-wrap p-3">  
                                        <div className="row flex-sm-row pb-3">
                                            <div className="mb-2 col-sm-4">
                                                <MyInput id="Name"
                                                    type="text"
                                                    key="Name"
                                                    name="Name"
                                                    heading="Batch Name"
                                                    value={this.state.rowData.Name ? this.state.rowData.Name : ""}
                                                    onChange={this.onTextChange}
                                                    isRequired={true}
                                                    errorState={this.state.classError}
                                                    errorMessage={this.state.classError} />
                                            </div>
                                            <div className="col-sm-4">
                                                <label className="card-holder-name">Batch Date<span className="color-red">*</span></label>
                                                <DatePicker className='w-100' onChange={this.onDateChange} format="DD-MMMM-YYYY" defaultValue={moment(this.state.rowData.Exam_Date).isValid() ? moment(this.state.rowData.Exam_Date) : ''} />
                                            </div>
                                            <div className="mb-2 col-sm-4">
                                                <MyInput id="Exam_Time"
                                                    type="text"
                                                    key="Exam_Time"
                                                    name="Exam_Time"
                                                    heading="Batch Time"
                                                    value={this.state.rowData.Exam_Time ? this.state.rowData.Exam_Time : ""}
                                                    onChange={this.onTextChange}
                                                    isRequired={true}
                                                    errorState={this.state.timeError}
                                                    errorMessage={this.state.timeError} />
                                            </div>
                                        </div>
                                        <div className="row flex-sm-row pb-3">
                                            <div className="col-sm-4">
                                                <DropdownList
                                                    value={this.state.rowData.Center_Id}
                                                    name="ParentId"
                                                    onChange={this.onCenterChange}
                                                    placeholder="Select Center"
                                                    heading={"Center"}
                                                    className="w-100"
                                                    wrapClass="wrap"
                                                    isRequired={true}
                                                    options={this.state.centerList}
                                                    errorState={this.state.centerError}
                                                    errorMessage={this.state.centerError}
                                                />
                                            </div>
                                        </div>
                                    </div>  
                                    <div className="pt-4 buttonAlignCenter" >
                                        <ButtonComponent type="button" value="Cancel" onClick={() => this.hideModelWindow()} className="button-global button-secondary mr-4 autoHeight small" />
                                        <ButtonComponent type="button" value="Save" onClick={this.handleUpdate} className="button-global button-primary autoHeight small" disabled={this.state.loading} />
                                    </div>
                                </div>
                            </div>              
                        }
                        <div className="max1200 m-auto">
                            <Table size='small'
                                bordered
                                rowKey='Id'
                                columns={TableColumns}
                                dataSource={this.state.data}
                                pagination={this.state.pagination}
                                footer={() => <label style={{ textAlign: 'right', marginRight: '20px' }}>Total Records: {this.state.data.length}</label>}
                                onChange={this.onTableAction}
                                rowClassName={(record, index) => (index % 2 ? 'odd' + (record.Id === this.state.highlightedRowID ? 'scroll-row table-row-dark' : '') :
                                    'even' + (record.Id === this.state.highlightedRowID ? 'scroll-row table-row-dark' : ''))}
                                className="table-striped-rows  admin-table"
                                locale={{ emptyText: <EmptyState icon="inbox" title="No Records Found" description="No batches have been added yet." /> }}
                            />
                        </div>      
                </div>  
                <Modal
                    centered={true}
                    width={400}
                    // bodyStyle={{
                    //     height: "150px",
                    //     padding: 0,
                    //     alignItems: "center",
                    //     justifyContent: "center",
                    //     display: " flex"
                    // }}
                    className="modelPopAnt admin-home"
                    visible={this.state.showMessageBox}
                    onCancel={() => this.closeMessageBox(false)}
                    footer={false}
                >
                    <ConfirmPopup
                        onCancel={() => this.closeMessageBox(false)}
                        onOk={this.onConfirmDelete}
                        popupData={this.state.rowData}
                        message="Are you sure, you want to delete this Center?"
                    />
                </Modal>
            </div>  
        )
    };
}

export default BatchMaster_new;